<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="headAction">
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="updatePassWord"
          >重置密码</a-button
        >
        <a-button style="margin-left:10px" type="primary" @click="setUserRole"
          >角色授权</a-button
        >
        <a-button style="margin-left:10px" type="primary" @click="bindWeChat"
          >微信绑定</a-button
        >
        <a-popconfirm
          title="确定解绑吗"
          ok-text="确定"
          cancel-text="取消"
          @confirm="unBindWeChat"
        >
          <a-button style="margin-left:10px" type="primary">解绑</a-button>
        </a-popconfirm>
        <a-button style="margin-left:10px" type="primary" @click="fileDown"
          >导出</a-button
        >
      </template>
    </data-table>

    <a-modal
      centered
      title="重置密码"
      :maskClosable="visible.maskClosable"
      v-model="visible.updatePassWordModal"
      @ok="handleOk"
      okText="确认"
    >
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="新密码"
          :labelCol="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input v-decorator="['Password']" type="password"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>

    <checkbox-tree
      title="角色授权"
      :visible="visible.qermissionModal"
      :option="qermissionOption"
      @submit="onSubmit"
      @close="onClose"
    />
    <a-modal
      title="微信绑定"
      :visible="visibleCode"
      @cancel="handleCancel"
      width="350px"
      :centered="true"
      :footer="null"
    >
      <a-spin :spinning="spinning">
        <div class="qr-box">
          <!-- <span>可点击二维码刷新</span> -->
          <img :src="imgurl" alt="微信绑定" />
          <p style="margin-top:10px">
            请<strong style="color:#f50">【{{ userName }}】</strong
            >使用微信扫码绑定
          </p>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import md5 from "js-md5";
import CheckboxTree from "@/components/dataTree/CheckboxTree";
import cloneDeep from "lodash/cloneDeep";
import { exportsDownLoad } from "@/utils/common";
export default {
  name: "userManage_user",
  components: {
    DataTable,
    CheckboxTree
  },
  data() {
    return {
      form: this.$form.createForm(this),
      visible: {
        maskClosable: false,
        updatePassWordModal: false,
        qermissionModal: false
      },
      editFormContent: [
        {
          label: "姓名",
          name: "Name",
          option: {
            rules: [{ required: true, message: "请填写姓名！" }]
          }
        },
        {
          label: "工号",
          name: "Code",
          option: {
            rules: [{ required: true, message: "请填写工号！" }]
          }
        },
        {
          label: "是否是操作员",
          name: "IsOperator",
          placeholder: "请选择",
          type: "select",
          valueField: "value", //可选项数据值字段
          textField: "text", //可选项数据文本字段
          // api: "",  //请求接口api
          // param:{},  //请求参数
          //dataField: "Data.IdentityDocType", //请求可选项返回的数据字段
          data: [
            //可选数据
            {
              value: true,
              text: "是"
            },
            {
              value: false,
              text: "否"
            }
          ],
          option: {
            rules: [{ required: true, message: "请填写操作员选项！" }]
          }
        },
        {
          label: "登录帐号",
          name: "Account"
          // option: {
          //   rules: [{ required: true, message: "请填写登录帐号！" }]
          // }
        },
        {
          label: "性别",
          name: "Sex",
          placeholder: "请选择",
          // option: {
          //   rules: [{ required: true, message: "请选择性别！" }]
          // },
          type: "select",
          valueField: "value", //可选项数据值字段
          textField: "text", //可选项数据文本字段
          data: [
            {
              value: true,
              text: "男"
            },
            {
              value: false,
              text: "女"
            }
          ]
        },
        {
          label: "联系电话",
          name: "Mobile"
        },
        {
          label: "生日",
          name: "Birthday",
          type: "date",
          placeholder: "请选择"
        },
        {
          label: "婚否",
          name: "Married",
          placeholder: "请选择",
          type: "select",
          valueField: "value", //可选项数据值字段
          textField: "text", //可选项数据文本字段
          data: [
            {
              value: true,
              text: "是"
            },
            {
              value: false,
              text: "否"
            }
          ]
        },
        {
          label: "籍贯",
          name: "Native"
        },
        {
          label: "家庭住址",
          name: "Address"
        },
        {
          label: "邮编",
          name: "ZipCode"
        },
        {
          label: "学历",
          name: "Academic"
        },
        {
          label: "身份证号",
          name: "IdCardNo"
        },
        {
          label: "部门",
          name: "DepartmentId",
          placeholder: "请选择",
          type: "select",
          api: "Common_GetSelect",
          param: { types: "department" },
          dataField: "Data.department"
        },
        {
          label: "职称",
          name: "Duty"
        },
        {
          label: "工资",
          name: "Salary"
        },
        {
          label: "录用方式",
          name: "EmployWay"
        },
        {
          label: "民族",
          name: "Nation"
        },
        {
          label: "录用日期",
          name: "EmployDate",
          type: "date",
          placeholder: "请选择"
        },
        {
          label: "离职日期",
          name: "DimissionDate",
          type: "date",
          placeholder: "请选择"
        },
        {
          label: "离职原因",
          name: "DimissionReason"
        },
        {
          label: "状态",
          name: "UserStatus",
          placeholder: "请选择",
          option: {
            rules: [{ required: true, message: "请选择状态！" }]
          },
          type: "select",
          valueField: "value", //可选项数据值字段
          textField: "text", //可选项数据文本字段
          data: [
            {
              value: 0,
              text: "离职"
            },
            {
              value: 1,
              text: "在职"
            }
          ]
        }
      ],
      qermissionOption: {
        id: "",
        api: "User_RoleList",
        textField: "Name",
        children: "",
        valueField: "Id",
        parentNode: false
      },
      imgurl: "",
      visibleCode: false,
      spinning: false,
      currentId: "",
      userName: ""
    };
  },
  created() {
    const _this = this;
    let addFormContent = cloneDeep(this.editFormContent);

    addFormContent.splice(4, 0, {
      label: "密码",
      name: "Password",
      type: "password"
    });
    this.option = {
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "用户编码",
            name: "Code"
          },
          {
            label: "用户名称",
            name: "Name"
          }
        ]
      },
      form: {
        colnum: 3,
        title: "用户",
        width: 1200,
        content: _this.editFormContent,
        add: {
          submitApi: "User_Add",
          content: addFormContent, //单独配置添加表单
          onOpenAfter: () => {
            return { UserStatus: 1, IsOperator: true }; //初始化数据
          },
          onSubmitBefore: values => {
            //新增表单提交前回调，return false 终止执行。如对数据做处理后，retrun 处理后的数据
            return this.onAddSubmitBefore(values);
          }
        },
        edit: {
          infoApi: "User_Info",
          submitApi: "User_Edit",
          onSubmitBefore: values => {
            if (values.IsOperator && !values.Account.trim()) {
              this.$message.info("用户为操作员时，登录帐号必填！");
              return false;
            }
          }
        },
        del: {
          submitApi: "User_Del"
        }
      },
      grid: {
        api: "User_List",
        columns: [
          {
            title: "序号",
            width: "5%",
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "用户编码",
            width: "15%",
            dataIndex: "Code" //列字段名
          },
          {
            title: "用户名称",
            width: "15%",
            dataIndex: "Name"
          },
          {
            title: "帐号",
            width: "12%",
            dataIndex: "Account"
          },
          {
            title: "微信号",
            width: "15%",
            dataIndex: "Wechat"
          },
          {
            title: "性别",
            width: "10%",
            dataIndex: "Sex",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="男" />;
              } else {
                return <a-badge status="error" text="女" />;
              }
            }
          },
          {
            title: "状态",
            width: "10%",
            dataIndex: "UserStatus",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="在职" />;
              } else {
                return <a-badge status="error" text="离职" />;
              }
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            key: "action",
            scopedSlots: { customRender: "rowAction" } //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    fileDown() {
      let url = this.$config.serverUrl + "" + "/api/User/ExportUserData";
      exportsDownLoad(url);
    },
    onAddSubmitBefore(values) {
      if (values.IsOperator && !values.Account.trim()) {
        this.$message.info("用户为操作员时，登录帐号必填！");
        return false;
      }
      values.Password = md5(values.Password);
      return values;
    },
    updatePassWord() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.visible.updatePassWordModal = true;
      this.form.setFieldsValue({ Password: "" });
    },
    handleOk() {
      this.handleSubmit();
    },
    handleSubmit() {
      const _this = this;
      let row = this.$refs.dataTable.getSelected();
      this.form.validateFields((err, values) => {
        if (!err) {
          const json = {
            Id: row.Id,
            Password: md5(values.Password ? values.Password : "")
          };
          _this.$post("User_ResetPassword", json).then(() => {
            this.visible.updatePassWordModal = false;
            this.$message.success("操作成功！");
          });
        }
      });
    },
    setUserRole() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.qermissionOption.id = row.Id;
      this.visible.qermissionModal = true;
    },
    onSubmit(type, treeData, checkedKeys) {
      let row = this.$refs.dataTable.getSelected();
      const json = { UserId: row.Id, RoleIds: checkedKeys };

      this.$post("User_SetRole", json).then(() => {
        this.visible.qermissionModal = false;
        this.$message.success("操作成功！");
      });
    },
    onClose() {
      this.visible.qermissionModal = false;
    },
    bindWeChat() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.currentId = row.Id;
      this.visibleCode = true;
      this.userName = row.Name;
      this.getQrCode();
    },
    getQrCode() {
      this.spinning = true;
      this.$post("WxAuth_GetBindQRCode", {
        Id: this.currentId,
        IsZYPlus: versionConfig.ZHIYUN_VERSION
      }).then(res => {
        this.spinning = false;
        this.imgurl = "data:image/jpeg;base64," + res.Data.QRCode;
      });
    },
    unBindWeChat() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$post("WxAuth_UnBind", {
        UserId: row.Id,
        IsZYPlus: versionConfig.ZHIYUN_VERSION
      }).then(() => {
        this.$message.success("操作成功！");
        this.$refs.dataTable.headSearch();
      });
    },
    handleCancel() {
      this.visibleCode = false;
      this.$refs.dataTable.headSearch();
    }
  }
};
</script>
<style lang="less" scoped></style>
